
export const dashboardAccessManager = (page:string)=>{
  
  const dashboardAccess = JSON.parse(localStorage.getItem("login-response"));
  const { dashboardPages } = dashboardAccess;
   
  if (dashboardPages?.length > 0 && dashboardPages?.includes(page)) {
      return true;
    } else {
      return false;
    }
}